import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getWISColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Anlagen-ID", accessorKey: "parameters.plantId" },
    { header: "Windpark Name", accessorKey: "parameters.parkName" },
    { header: "Anlagenname", accessorKey: "parameters.plantName" },
    { header: "Seriennummer", accessorKey: "parameters.serialNumber" }
  ];
}

export { getWISColumns };
